import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import LazyImage from '../components/LazyImage';

const CheckIcon = () => (
  <svg className="w-5 h-5 text-aqua-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
  </svg>
);

const Services = () => {
  const navigate = useNavigate();

  const services = [
    {
      title: "Swimming Pool Construction Bangalore",
      description: "Transform your outdoor space with custom-designed luxury swimming pools built by Bangalore's top pool builders",
      image: "https://images.unsplash.com/photo-1554629790-aa24de70f739?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxpbmZpbml0eSUyMHBvb2wlMjBjb25zdHJ1Y3Rpb24lMjBsdXh1cnklMjBtb2Rlcm4lMjBkZXNpZ258ZW58MHx8fHwxNzcwMDU1NDIzfDA&ixlib=rb-4.1.0&q=85",
      features: [
        "Custom pool design consultation in Bangalore",
        "Residential and commercial pool construction",
        "Infinity pools, lap pools, and luxury pools",
        "Modern pipeless filtration systems",
        "Energy-efficient pool equipment",
        "Landscaping integration",
        "LED underwater lighting installation",
        "Water feature additions"
      ]
    },
    {
      title: "Swimming Pool AMC Bangalore",
      description: "Comprehensive annual maintenance contracts keeping your Bangalore pool pristine year-round",
      image: "https://images.unsplash.com/photo-1697967069844-1caf4515faa5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxzd2ltbWluZyUyMHBvb2wlMjBjbGVhbiUyMHdhdGVyJTIwbWFpbnRlbmFuY2UlMjBibHVlfGVufDB8fHx8MTc3MDA1NTQyN3ww&ixlib=rb-4.1.0&q=85",
      features: [
        "Regular cleaning and vacuuming",
        "Chemical balancing and water testing",
        "Filter cleaning and maintenance",
        "Equipment inspection and servicing",
        "Annual Maintenance Contracts (AMC)",
        "Emergency repair services in Bangalore",
        "Seasonal pool opening and closing",
        "Water quality monitoring"
      ]
    },
    {
      title: "Pool Renovation & Waterproofing Bangalore",
      description: "Expert pool renovation and waterproofing services by Bangalore's pool waterproofing experts",
      image: "https://images.unsplash.com/photo-1715644678117-d703a6330b80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxwb29sJTIwdGlsZSUyMG1vc2FpYyUyMGJsdWUlMjByZW5vdmF0aW9ufGVufDB8fHx8MTc3MDA1NTQzM3ww&ixlib=rb-4.1.0&q=85",
      features: [
        "Pool resurfacing and premium tiling",
        "Leak detection and waterproofing repair",
        "SOPREMAPOOL liner waterproofing systems",
        "Plumbing repairs and upgrades",
        "Pool deck restoration",
        "Pool modernisation and upgrades",
        "LED lighting upgrades",
        "Automation system installation"
      ]
    },
    {
      title: "Jacuzzi & Sauna Installation Bangalore",
      description: "Luxury jacuzzi massage bathtub and sauna installation for homes, villas, and resorts in Bangalore",
      image: "https://images.unsplash.com/photo-1761673271363-6efe71f08d18?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxqYWN1enppJTIwaG90JTIwdHViJTIwc3BhJTIwYmF0aHR1YiUyMGx1eHVyeSUyMGJhdGhyb29tfGVufDB8fHx8MTc3MDA1NTQzOHww&ixlib=rb-4.1.0&q=85",
      features: [
        "Hydrotherapy innovation with strategic jets",
        "Adjustable massage options",
        "Intuitive user-friendly controls",
        "Ergonomic comfort design",
        "Chromotherapy lighting integration",
        "Aromatherapy compatibility",
        "Premium durable construction",
        "2-seater and 4-seater models available"
      ]
    },
    {
      title: "Authorised SOPREMAPOOL Liner Dealer",
      description: "Premium reinforced synthetic membranes for swimming pools - Your gateway to SOPREMA's world-class waterproofing systems",
      image: "https://images.unsplash.com/photo-1650308963521-3ec2fa1cf709?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxwb29sJTIwbGluZXIlMjBibHVlJTIwbWVtYnJhbmUlMjBzd2ltbWluZ3xlbnwwfHx8fDE3NzAwNTU0NDN8MA&ixlib=rb-4.1.0&q=85",
      isSpecial: true,
      features: [
        "World-renowned SOPREMA waterproofing systems",
        "High-quality reinforced synthetic membranes",
        "Suitable for new construction and renovations",
        "Compatible with concrete, polystyrene, metal panels",
        "Private, public, and water park applications",
        "Perfect visual results guaranteed",
        "Expert installation and maintenance support",
        "Full warranties and guarantees"
      ]
    }
  ];

  return (
    <div className="min-h-screen">
      <section className="relative h-96 flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img 
            src="https://images.unsplash.com/photo-1763479142678-8e29f4edb538?w=1920&q=80"
            alt="Services"
            loading="eager"
            fetchPriority="high"
            decoding="async"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-navy-900/70"></div>
        </div>
        
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-5xl md:text-6xl font-bold mb-4">Our Services in Bangalore</h1>
          <p className="text-xl md:text-2xl mb-2">Comprehensive Pool & Spa Solutions in Karnataka</p>
          <p className="text-lg text-aqua-300 font-semibold">Swimming Pool Construction, AMC, Renovation & Jacuzzi Installation</p>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-b from-white to-cream-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-3xl font-bold text-navy-900 mb-4">Bangalore's Complete Pool Service Provider</h2>
            <p className="text-lg text-gray-600">From swimming pool construction and waterproofing to annual maintenance contracts and luxury jacuzzi installation — Aquarist Pools delivers premium pool services across Bangalore, Karnataka, and pan India.</p>
          </div>
          <div className="space-y-24">
            {services.map((service, index) => (
              <div key={index} className={`grid md:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? '' : ''}`}>
                <div className={index % 2 === 1 ? 'md:order-2' : ''}>
                  <Card className="border-0 shadow-2xl overflow-hidden group">
                    <LazyImage 
                      src={service.image}
                      alt={service.title}
                      className="w-full h-80"
                    />
                  </Card>
                </div>
                
                <div className={index % 2 === 1 ? 'md:order-1' : ''}>
                  {service.isSpecial && (
                    <div className="inline-block bg-gradient-to-r from-aqua-500 to-aqua-600 text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">
                      Authorised Dealer in Bengaluru
                    </div>
                  )}
                  <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4">
                    {service.title}
                  </h2>
                  <p className="text-xl text-gray-600 mb-6">
                    {service.description}
                  </p>
                  
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
                    {service.features.map((feature, idx) => (
                      <div key={idx} className="flex items-start gap-2">
                        <CheckIcon />
                        <span className="text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                  
                  {service.isSpecial ? (
                    <div className="flex flex-wrap gap-4">
                      <Button 
                        size="lg"
                        onClick={() => window.open('https://www.sopremapool.com/en', '_blank')}
                        className="bg-navy-900 hover:bg-navy-800 text-white px-6 py-6 text-lg"
                      >
                        Visit SOPREMAPOOL Website →
                      </Button>
                      <Button 
                        size="lg"
                        onClick={() => navigate('/booking')}
                        className="bg-aqua-500 hover:bg-aqua-600 text-white px-6 py-6 text-lg"
                      >
                        Request a Quote
                      </Button>
                    </div>
                  ) : (
                    <Button 
                      size="lg"
                      onClick={() => navigate('/booking')}
                      className="bg-aqua-500 hover:bg-aqua-600 text-white px-6 py-6 text-lg"
                    >
                      Request a Quote →
                    </Button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SOPREMAPOOL Detailed Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="inline-block bg-gradient-to-r from-aqua-500 to-aqua-600 text-white px-6 py-3 rounded-full text-sm font-bold mb-6">
              Authorised Dealer
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-navy-900 mb-4">
              Aquarist Pools & Fitness
            </h2>
            <p className="text-2xl text-gray-700 font-semibold">
              Your Authorised SOPREMAPOOL Liner Dealer in Bengaluru, India
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-start mb-16">
            <div>
              <Card className="border-0 shadow-2xl overflow-hidden">
                <LazyImage 
                  src="https://images.unsplash.com/photo-1727102013163-08ff175d3a62?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxpbmZpbml0eSUyMHBvb2wlMjBjb25zdHJ1Y3Rpb24lMjBsdXh1cnklMjBtb2Rlcm4lMjBkZXNpZ258ZW58MHx8fHwxNzcwMDU1NDIzfDA&ixlib=rb-4.1.0&q=85"
                  alt="SOPREMAPOOL Liner Installation"
                  className="w-full h-80"
                />
              </Card>
            </div>

            <div className="space-y-6">
              <p className="text-lg text-gray-700">
                We are delighted to announce that <strong>Aquarist Pools & Fitness is now an authorised dealer for SOPREMAPOOL Liner,</strong> headquartered in Bengaluru, India. SOPREMA, a global leader in waterproofing systems, presents an extensive range of reinforced synthetic membranes and complementary products for swimming pools under the brand SOPREMAPOOL.
              </p>

              <div className="bg-gradient-to-br from-aqua-50 to-cream-50 p-6 rounded-lg border border-aqua-200">
                <h3 className="text-2xl font-bold text-navy-900 mb-3">About SOPREMAPOOL</h3>
                <p className="text-gray-700 mb-4">
                  SOPREMAPOOL, a division of SOPREMA, is a world-renowned manufacturer of waterproofing systems. Its product line includes high-quality reinforced synthetic membranes designed for the installation and maintenance of swimming pools.
                </p>
                <a 
                  href="https://www.sopremapool.com/en" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-aqua-600 hover:text-aqua-700 font-semibold"
                >
                  Visit SOPREMAPOOL's Website →
                </a>
              </div>
            </div>
          </div>

          {/* Key Features */}
          <div className="mb-16">
            <h3 className="text-3xl font-bold text-navy-900 mb-8 text-center">
              Key Features of SOPREMAPOOL Liner
            </h3>
            
            <div className="grid md:grid-cols-3 gap-8">
              <Card className="border-0 shadow-lg hover:shadow-xl transition-shadow">
                <div className="p-8">
                  <div className="w-16 h-16 bg-gradient-to-br from-aqua-500 to-aqua-600 rounded-full flex items-center justify-center mb-6">
                    <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <h4 className="text-xl font-bold text-navy-900 mb-3">
                    Waterproof, Protect, Decorate
                  </h4>
                  <p className="text-gray-600">
                    SOPREMAPOOL membranes are meticulously designed to waterproof, protect, and enhance the aesthetic appeal of your pool.
                  </p>
                </div>
              </Card>

              <Card className="border-0 shadow-lg hover:shadow-xl transition-shadow">
                <div className="p-8">
                  <div className="w-16 h-16 bg-gradient-to-br from-aqua-500 to-aqua-600 rounded-full flex items-center justify-center mb-6">
                    <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z" />
                    </svg>
                  </div>
                  <h4 className="text-xl font-bold text-navy-900 mb-3">
                    Versatile Applications
                  </h4>
                  <p className="text-gray-600">
                    Ideal for both newly built pools and the renovation of existing ones. Suitable for private, public, or water park pools.
                  </p>
                </div>
              </Card>

              <Card className="border-0 shadow-lg hover:shadow-xl transition-shadow">
                <div className="p-8">
                  <div className="w-16 h-16 bg-gradient-to-br from-aqua-500 to-aqua-600 rounded-full flex items-center justify-center mb-6">
                    <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <h4 className="text-xl font-bold text-navy-900 mb-3">
                    Universal Compatibility
                  </h4>
                  <p className="text-gray-600">
                    Can be seamlessly installed on reinforced concrete, precast concrete, polystyrene formwork, and precast metal panels.
                  </p>
                </div>
              </Card>
            </div>
          </div>

          {/* Why Choose Section */}
          <div className="bg-gradient-to-br from-navy-900 to-navy-800 text-white rounded-2xl p-8 md:p-12">
            <h3 className="text-3xl md:text-4xl font-bold mb-8 text-center">
              Why Choose SOPREMAPOOL Liner with Aquarist Pools & Fitness
            </h3>
            
            <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-aqua-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-white font-bold">✓</span>
                </div>
                <p className="text-lg">Access to SOPREMAPOOL's premium range of products</p>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-aqua-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-white font-bold">✓</span>
                </div>
                <p className="text-lg">Cutting-edge technology for superior pool solutions</p>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-aqua-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-white font-bold">✓</span>
                </div>
                <p className="text-lg">Expert support and guidance throughout your journey</p>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-aqua-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-white font-bold">✓</span>
                </div>
                <p className="text-lg">Assurance of warranties and guarantees for peace of mind</p>
              </div>
            </div>

            <div className="mt-10 text-center">
              <p className="text-xl mb-6">
                Visit our head office in Bengaluru, India, or explore the world of SOPREMAPOOL Liner with us online.
              </p>
              <p className="text-2xl font-semibold text-aqua-400 mb-8">
                Thank you for choosing Aquarist Pools & Fitness – Your Gateway to Extraordinary Pool Experiences!
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <Button 
                  size="lg"
                  onClick={() => window.open('https://www.sopremapool.com/en', '_blank')}
                  className="bg-aqua-500 hover:bg-aqua-600 text-white px-8 py-6 text-lg"
                >
                  Explore SOPREMAPOOL
                </Button>
                <Button 
                  size="lg"
                  onClick={() => navigate('/contact')}
                  className="bg-white text-navy-900 hover:bg-cream-50 px-8 py-6 text-lg"
                >
                  Contact Us
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Jacuzzi Massage Bathtub Detailed Section */}
      <section className="py-20 bg-gradient-to-b from-cream-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-navy-900 mb-4">
              Explore Our Wide Range
            </h2>
            <p className="text-3xl text-aqua-600 font-bold mb-2">
              Jacuzzi Massage Bathtub
            </p>
            <p className="text-xl text-gray-700">
              Discover Luxury and Relaxation with Aquarist Pools & Fitness
            </p>
          </div>

          <div className="max-w-4xl mx-auto mb-16">
            <p className="text-lg text-gray-700 text-center leading-relaxed">
              Aquarist Pools & Fitness is delighted to present an exquisite collection of Jacuzzi Massage Bathtubs, designed to bring the epitome of luxury and relaxation to your home. Immerse yourself in the perfect blend of advanced technology, ergonomic design, and unparalleled comfort with our Jacuzzi Massage Bathtubs.
            </p>
          </div>

          {/* 2-Seater Jacuzzi Showcase */}
          <div className="mb-20">
            <div className="text-center mb-8">
              <span className="inline-block bg-[#00AEEF]/10 text-[#00AEEF] font-bold text-sm tracking-widest uppercase px-6 py-2 rounded-full mb-3">Compact Luxury</span>
              <h3 className="text-3xl font-bold text-navy-900">2-Seater Jacuzzi Massage Bathtub</h3>
              <p className="text-gray-600 mt-2">Perfect for couples and master bathrooms — intimate relaxation redefined.</p>
            </div>
            <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
              <Card className="border-0 shadow-xl overflow-hidden group">
                <LazyImage
                  src="https://static.prod-images.emergentagent.com/jobs/c9ad710f-4465-477e-b650-f23470cb69ef/images/090988a8360b49bc0b79154f55e37bfe7a7e01960b76e0a8ba6c5f919b47e868.png"
                  alt="2-Seater Jacuzzi Massage Bathtub with LED lighting and hydrotherapy jets"
                  className="w-full h-72"
                />
                <div className="p-4 bg-white">
                  <p className="text-sm font-semibold text-[#003366]">Modern 2-Seater Whirlpool Bathtub</p>
                  <p className="text-xs text-gray-500">Chrome fixtures, LED ambient lighting, hydrotherapy jets</p>
                </div>
              </Card>
              <Card className="border-0 shadow-xl overflow-hidden group">
                <LazyImage
                  src="https://static.prod-images.emergentagent.com/jobs/c9ad710f-4465-477e-b650-f23470cb69ef/images/e668d93f7c064062b8434ee4499cdf5403174cdaafc23285aee6b0be448ce928.png"
                  alt="2-Seater Jacuzzi Bathtub top view with massage jets and digital controls"
                  className="w-full h-72"
                />
                <div className="p-4 bg-white">
                  <p className="text-sm font-semibold text-[#003366]">2-Person Whirlpool with Digital Controls</p>
                  <p className="text-xs text-gray-500">Blue LED underwater lights, built-in armrests, bubbling jets</p>
                </div>
              </Card>
            </div>
          </div>

          {/* 4-Seater Jacuzzi Showcase */}
          <div className="mb-20">
            <div className="text-center mb-8">
              <span className="inline-block bg-[#003366]/10 text-[#003366] font-bold text-sm tracking-widest uppercase px-6 py-2 rounded-full mb-3">Ultimate Experience</span>
              <h3 className="text-3xl font-bold text-navy-900">4-Seater Jacuzzi Massage Bathtub</h3>
              <p className="text-gray-600 mt-2">Designed for families and entertainment — spacious luxury for your home or resort.</p>
            </div>
            <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
              <Card className="border-0 shadow-xl overflow-hidden group">
                <LazyImage
                  src="https://static.prod-images.emergentagent.com/jobs/c9ad710f-4465-477e-b650-f23470cb69ef/images/0b3eb9ff62e76f08f705953c3f510850ae2f7cce094def01deaaa8d24ab95958.png"
                  alt="4-Seater Outdoor Hot Tub Jacuzzi Spa on wooden deck with garden"
                  className="w-full h-72"
                />
                <div className="p-4 bg-white">
                  <p className="text-sm font-semibold text-[#003366]">4-Seater Outdoor Hot Tub Spa</p>
                  <p className="text-xs text-gray-500">Deck-mounted, ambient lighting, multiple massage jets, headrests</p>
                </div>
              </Card>
              <Card className="border-0 shadow-xl overflow-hidden group">
                <LazyImage
                  src="https://static.prod-images.emergentagent.com/jobs/c9ad710f-4465-477e-b650-f23470cb69ef/images/b4578394cada644edc4d07f58b227f3b6b9cdd3507fbd6dcdd472f91caa74538.png"
                  alt="4-Seater Indoor Jacuzzi with waterfall and blue LED lighting"
                  className="w-full h-72"
                />
                <div className="p-4 bg-white">
                  <p className="text-sm font-semibold text-[#003366]">4-Person Indoor Luxury Jacuzzi</p>
                  <p className="text-xs text-gray-500">Cascading waterfall, blue LED lights, spacious seating</p>
                </div>
              </Card>
            </div>
          </div>

          {/* Key Features Grid */}
          <div className="mb-16">
            <h3 className="text-3xl font-bold text-navy-900 mb-10 text-center">
              Key Features of Our Jacuzzi Massage Bathtubs
            </h3>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              <Card className="border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="p-6">
                  <div className="w-14 h-14 bg-gradient-to-br from-aqua-500 to-aqua-600 rounded-lg flex items-center justify-center mb-4">
                    <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <h4 className="text-lg font-bold text-navy-900 mb-2">
                    Hydrotherapy Innovation
                  </h4>
                  <p className="text-gray-600 text-sm">
                    Experience therapeutic power with strategically placed jets providing soothing massage to tension areas
                  </p>
                </div>
              </Card>

              <Card className="border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="p-6">
                  <div className="w-14 h-14 bg-gradient-to-br from-aqua-500 to-aqua-600 rounded-lg flex items-center justify-center mb-4">
                    <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <h4 className="text-lg font-bold text-navy-900 mb-2">
                    Adjustable Massage Options
                  </h4>
                  <p className="text-gray-600 text-sm">
                    Customize your experience by tailoring jet intensity and focus to your preferences
                  </p>
                </div>
              </Card>

              <Card className="border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="p-6">
                  <div className="w-14 h-14 bg-gradient-to-br from-aqua-500 to-aqua-600 rounded-lg flex items-center justify-center mb-4">
                    <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM14 11a1 1 0 011 1v1h1a1 1 0 110 2h-1v1a1 1 0 11-2 0v-1h-1a1 1 0 110-2h1v-1a1 1 0 011-1z" />
                    </svg>
                  </div>
                  <h4 className="text-lg font-bold text-navy-900 mb-2">
                    Intuitive Controls
                  </h4>
                  <p className="text-gray-600 text-sm">
                    User-friendly controls to adjust jet strength, water temperature, and features effortlessly
                  </p>
                </div>
              </Card>

              <Card className="border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="p-6">
                  <div className="w-14 h-14 bg-gradient-to-br from-aqua-500 to-aqua-600 rounded-lg flex items-center justify-center mb-4">
                    <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" />
                    </svg>
                  </div>
                  <h4 className="text-lg font-bold text-navy-900 mb-2">
                    Ergonomic Comfort
                  </h4>
                  <p className="text-gray-600 text-sm">
                    Ergonomic designs that cradle your body for luxurious rejuvenating sessions
                  </p>
                </div>
              </Card>

              <Card className="border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="p-6">
                  <div className="w-14 h-14 bg-gradient-to-br from-aqua-500 to-aqua-600 rounded-lg flex items-center justify-center mb-4">
                    <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M11 3a1 1 0 10-2 0v1a1 1 0 102 0V3zM15.657 5.757a1 1 0 00-1.414-1.414l-.707.707a1 1 0 001.414 1.414l.707-.707zM18 10a1 1 0 01-1 1h-1a1 1 0 110-2h1a1 1 0 011 1zM5.05 6.464A1 1 0 106.464 5.05l-.707-.707a1 1 0 00-1.414 1.414l.707.707zM5 10a1 1 0 01-1 1H3a1 1 0 110-2h1a1 1 0 011 1zM8 16v-1h4v1a2 2 0 11-4 0zM12 14c.015-.34.208-.646.477-.859a4 4 0 10-4.954 0c.27.213.462.519.476.859h4.002z" />
                    </svg>
                  </div>
                  <h4 className="text-lg font-bold text-navy-900 mb-2">
                    Chromotherapy Lighting
                  </h4>
                  <p className="text-gray-600 text-sm">
                    Built-in chromotherapy lighting for calming ambience and enhanced well-being
                  </p>
                </div>
              </Card>

              <Card className="border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="p-6">
                  <div className="w-14 h-14 bg-gradient-to-br from-aqua-500 to-aqua-600 rounded-lg flex items-center justify-center mb-4">
                    <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M5 2a1 1 0 011 1v1h1a1 1 0 010 2H6v1a1 1 0 01-2 0V6H3a1 1 0 010-2h1V3a1 1 0 011-1zm0 10a1 1 0 011 1v1h1a1 1 0 110 2H6v1a1 1 0 11-2 0v-1H3a1 1 0 110-2h1v-1a1 1 0 011-1zM12 2a1 1 0 01.967.744L14.146 7.2 17.5 9.134a1 1 0 010 1.732l-3.354 1.935-1.18 4.455a1 1 0 01-1.933 0L9.854 12.8 6.5 10.866a1 1 0 010-1.732l3.354-1.935 1.18-4.455A1 1 0 0112 2z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <h4 className="text-lg font-bold text-navy-900 mb-2">
                    Aromatherapy Integration
                  </h4>
                  <p className="text-gray-600 text-sm">
                    Elevate your senses with integrated aromatherapy for enhanced relaxation
                  </p>
                </div>
              </Card>

              <Card className="border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="p-6">
                  <div className="w-14 h-14 bg-gradient-to-br from-aqua-500 to-aqua-600 rounded-lg flex items-center justify-center mb-4">
                    <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <h4 className="text-lg font-bold text-navy-900 mb-2">
                    Premium Construction
                  </h4>
                  <p className="text-gray-600 text-sm">
                    Crafted with highest quality materials ensuring durability and luxury aesthetic
                  </p>
                </div>
              </Card>

              <Card className="border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="p-6">
                  <div className="w-14 h-14 bg-gradient-to-br from-aqua-500 to-aqua-600 rounded-lg flex items-center justify-center mb-4">
                    <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
                    </svg>
                  </div>
                  <h4 className="text-lg font-bold text-navy-900 mb-2">
                    Variety of Styles
                  </h4>
                  <p className="text-gray-600 text-sm">
                    Diverse range from modern sleek designs to classic timeless tubs for any space
                  </p>
                </div>
              </Card>
            </div>
          </div>

          {/* Why Choose Section */}
          <div className="bg-gradient-to-br from-aqua-500 to-aqua-600 text-white rounded-2xl p-8 md:p-12">
            <h3 className="text-3xl md:text-4xl font-bold mb-8 text-center">
              Why Choose Aquarist Pools & Fitness for Your Jacuzzi Massage Bathtub
            </h3>
            
            <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-10">
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-white font-bold">✓</span>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold mb-1">Expert Guidance</h4>
                    <p className="text-aqua-50">Our knowledgeable team assists you in selecting the perfect Jacuzzi that aligns with your preferences and bathroom layout</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-white font-bold">✓</span>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold mb-1">Quality Assurance</h4>
                    <p className="text-aqua-50">We source Jacuzzi Bathtubs from reputable manufacturers, guaranteeing exceptional quality and performance</p>
                  </div>
                </div>
              </div>
              
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-white font-bold">✓</span>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold mb-1">Professional Installation</h4>
                    <p className="text-aqua-50">Rely on our experts for seamless installation services ensuring optimal enjoyment</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-white font-bold">✓</span>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold mb-1">Customer Satisfaction</h4>
                    <p className="text-aqua-50">Your satisfaction is our priority. We provide a bathing experience that surpasses expectations</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center">
              <p className="text-xl mb-6">
                Elevate your bathing ritual to new heights with Aquarist Pools & Fitness. Explore our collection of Jacuzzi Massage Bathtubs and embrace a world of relaxation and indulgence.
              </p>
              <p className="text-2xl font-bold mb-8">
                Transform your bathroom into a sanctuary of luxury and well-being!
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <Button 
                  size="lg"
                  onClick={() => navigate('/booking')}
                  className="bg-white text-aqua-600 hover:bg-cream-50 px-8 py-6 text-lg font-semibold"
                >
                  Request a Quote
                </Button>
                <Button 
                  size="lg"
                  onClick={() => navigate('/contact')}
                  className="bg-navy-900 hover:bg-navy-800 text-white px-8 py-6 text-lg"
                >
                  Contact Us Today
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-navy-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Ready to Get Started in Bangalore?</h2>
          <p className="text-xl mb-8 text-gray-300">
            Contact Bangalore's trusted pool builders today to discuss your pool or spa project
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Button 
              size="lg"
              onClick={() => window.location.href = 'tel:+917757999805'}
              className="bg-aqua-500 hover:bg-aqua-600 text-white px-8 py-6 text-lg"
            >
              Call 077579 99805
            </Button>
            <Button 
              size="lg"
              onClick={() => navigate('/contact')}
              className="bg-white text-navy-900 hover:bg-cream-50 px-8 py-6 text-lg"
            >
              Contact Us
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
